export const textSizes = {
  xxs: "tw-text-xxs",
  xs: "tw-text-xs",
  sm: "tw-text-sm",
  base: "tw-text-base",
  lg: "tw-text-lg",
};
